import { Breadcrumbs, Link, Typography } from "@mui/material";
import "./breadcrumb.css";

type crumbValue = {
  name: string;
  link?: string;
};

type breadCrumbProps = {
  props: crumbValue[];
  firstCrumbName?: string;
  firstCrumbLink?: string;
  disable?: boolean;
};

export default function BreadCrumbGeneric(c: breadCrumbProps) {
  if (!!c.disable) {
    return <></>;
  }
  const firstCrumb = (
    <Link
      underline="none"
      color="inherit"
      href={
        c.firstCrumbLink === undefined
          ? `${process.env.PORTAL_URL}`
          : c.firstCrumbLink
      }
    >
      {c.firstCrumbName === undefined ? "Início" : c.firstCrumbName}
    </Link>
  );

  return (
    <div className={"breadcrumb-content"}>
      <div className="xvia-container breadcrumb-info_container">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
          {firstCrumb}
          {c.props.map((value, index) =>
            index === c.props.length - 1 ? (
              <Typography className="breadcrumb">{value.name}</Typography>
            ) : (
              <Link underline="none" color="inherit" href={value.link}>
                {value.name}
              </Link>
            )
          )}
        </Breadcrumbs>
      </div>
    </div>
  );
}
